const JOURNEY_TITLES = {
  WAYBILL_CREATED: '创建运单', WAYBILL_CANCELED: '作废运单',
  TRANSPORT_STARTED: '开始运输', TRANSPORT_FINISHED: '完成运输',
  START_ARRIVED: '驶入起始地', START_DEPARTED: '驶出起始地',
  DESTINATION_ARRIVED: '驶入目的地', DESTINATION_DEPARTED: '驶出目的地',
  STOPOVER_ARRIVED: '驶入经停点', STOPOVER_DEPARTED: '驶出经停点',
  WAYPOINT_ENTERED: '驶入途中围栏', WAYPOINT_EXITED: '驶出途中围栏'
}

function timestamp(value) {
  if (value === null || value === undefined || value === '') return null
  const numeric = Number(value)
  const time = Number.isFinite(numeric) ? (numeric < 100000000000 ? numeric * 1000 : numeric) : new Date(value).getTime()
  return Number.isFinite(time) && time > 0 ? time : null
}

function numberValue(value) {
  if (value === null || value === undefined || value === '') return null
  const number = Number(value)
  return Number.isFinite(number) && number >= 0 ? number : null
}

function buildWaybillEvents({ parkingPoints = [], journeyEvents = [], alarms = [], waybillNo = '', alarmLabel = alarm => alarm.alarmType || '告警' } = {}) {
  const events = new Map()
  const scope = item => String(item.waybillNo || waybillNo)
  const linkedAlarms = new Set()
  journeyEvents.forEach((event, index) => {
    const time = timestamp(event.eventTime)
    if (time === null) return
    const key = `journey:${scope(event)}:${event.eventId || event.id || index}`
    if (event.sourceAlarmNo) linkedAlarms.add(`${scope(event)}:${event.sourceAlarmNo}`)
    events.set(key, { key, category: 'journey', title: JOURNEY_TITLES[event.nodeType] || event.nodeName || event.nodeType || '行程事件', time, address: event.address || '', remark: event.nodeName || '', waybillNo: scope(event), source: event })
  })
  parkingPoints.forEach((parking, index) => {
    const start = timestamp(parking.startTime)
    if (start === null) return
    const key = `parking:${scope(parking)}:${parking.key || index}`
    const base = { category: 'parking', address: parking.locationName || '', duration: parking.duration, waybillNo: scope(parking), source: parking }
    events.set(`${key}:start`, { ...base, key: `${key}:start`, title: '停车开始', time: start, ongoing: parking.ended === false })
    const end = timestamp(parking.endTime)
    if (parking.ended !== false && end !== null && end >= start) events.set(`${key}:end`, { ...base, key: `${key}:end`, title: '停车结束', time: end })
  })
  alarms.forEach((alarm, index) => {
    const time = timestamp(alarm.alarmTime || alarm.createTime)
    const resolved = Number(alarm.alarmFlag) === 2
    if (time === null || (!resolved && alarm.alarmNo && linkedAlarms.has(`${scope(alarm)}:${alarm.alarmNo}`))) return
    const key = `alarm:${scope(alarm)}:${alarm.alarmNo || alarm.id || index}:${resolved ? 'resolved' : 'raised'}`
    events.set(key, { key, category: 'alarm', title: `${alarmLabel(alarm)}${resolved ? '解除' : ''}`, resolved, time, address: alarm.alarmAddress || '', remark: alarm.alarmRemark || '', waybillNo: scope(alarm), source: alarm })
  })
  return Array.from(events.values()).sort((a, b) => a.time - b.time || a.key.localeCompare(b.key))
}

function summarizeWaybillTracks(tracks = [], suppliedDistance, suppliedSeconds) {
  const ordered = tracks.filter(item => timestamp(item.locationTime) !== null).slice().sort((a, b) => timestamp(a.locationTime) - timestamp(b.locationTime))
  // 采样里程可能来自不同计数器，不能代替后端提供的可信全程总里程。
  const distance = numberValue(suppliedDistance)
  const seconds = numberValue(suppliedSeconds) !== null ? numberValue(suppliedSeconds) : (ordered.length > 1 ? Math.max(0, Math.floor((timestamp(ordered[ordered.length - 1].locationTime) - timestamp(ordered[0].locationTime)) / 1000)) : null)
  const speeds = ordered.map(item => numberValue(item.speed)).filter(value => value !== null)
  return { distance, seconds, averageSpeed: distance !== null && seconds > 0 ? distance * 3600 / seconds : null, maxSpeed: speeds.length ? Math.max(...speeds) : null }
}

module.exports = { buildWaybillEvents, summarizeWaybillTracks }
